<owl-carousel-o [options]="hotelCardLoader">
  <ng-container>
    <ng-template carouselSlide >
      <div class="wrapper wrapperBox">
        <div class="imgWrapper">
        </div>
        <div class="contentWrapper">
          <div class="heading">
            <h3></h3>
          </div>
          <div class="location">
            <p></p>
          </div>
          <div class="amountGuest">
            <p></p>
            <button mat-button class="secoundary"></button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template carouselSlide >
      <div class="wrapper wrapperBox">
        <div class="imgWrapper">
          <!-- <img src="../../../assets/b2c/hotel/hotel_dummy.png" alt="" class="img-fluid"> -->
        </div>
        <div class="contentWrapper">
          <div class="heading">
            <h3></h3>
          </div>
          <div class="location">
            <p></p>
          </div>
          <div class="amountGuest">
            <p></p>
            <button mat-button class="secoundary"></button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template carouselSlide >
      <div class="wrapper wrapperBox">
        <div class="imgWrapper">
        </div>
        <div class="contentWrapper">
          <div class="heading">
            <h3></h3>
          </div>
          <div class="location">
            <p></p>
          </div>
          <div class="amountGuest">
            <p></p>
            <button mat-button class="secoundary"></button>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template carouselSlide >
      <div class="wrapper wrapperBox">
        <div class="imgWrapper">
        </div>
        <div class="contentWrapper">
          <div class="heading">
            <h3></h3>
          </div>
          <div class="location">
            <p></p>
          </div>
          <div class="amountGuest">
            <p></p>
            <button mat-button class="secoundary"></button>
          </div>
        </div>
      </div>
    </ng-template>
  </ng-container>
</owl-carousel-o>
